/**
 * Standalone functionality of app.fortherecord.com that can be enabled or disabled
 * for a court system.
 */
export var FeatureName;
(function (FeatureName) {
    /**
     * The ability of the public to order a transcript of a court's hearing.
     */
    FeatureName["TranscriptOrdering"] = "TranscriptOrdering";
    /**
     * The ability of the public to order audio of a court's hearing.
     */
    FeatureName["AudioOrdering"] = "AudioOrdering";
    /**
     * The ability for a court system to play back audio recordings.
     */
    FeatureName["AudioPlayback"] = "AudioPlayback";
    /**
     * The ability for a court to download, install and run Real-Time recorders, to start livestreams.
     */
    FeatureName["RealTimeRecorders"] = "RealTimeRecorders";
    /**
     * The ability of the public to join a court hearing in real time.
     */
    FeatureName["RealTimeOrdering"] = "RealTimeOrdering";
    /**
     * The ability to schedule, moderate proceedings.
     */
    FeatureName["DigitalJustice"] = "DigitalJustice";
    /**
     * The ability to archive/delete files after a certain amount of time.
     */
    FeatureName["Archiving"] = "Archiving";
    /**
     * The ability to share recordings.
     */
    FeatureName["SharingRecordings"] = "SharingRecordings";
    /**
     * The ability to download bundles from recordings directly and shared recordings.
     * Does not affect transcriber bundles.
     */
    FeatureName["BundleDownloads"] = "BundleDownloads";
})(FeatureName || (FeatureName = {}));
export const ALL_FEATURE_NAMES = Object.keys(FeatureName).map(key => FeatureName[key]);
